<template>
  <div class="sectionOuterBox bgTealBlue cWhite">
    <div class="sectionInnerBox text-left py-12">
      <v-container class="container">
        <v-row>
          <v-col md="6" sm="12">
            <div class="sectionListHeader md">{{ $t('schools.teacher.title') }}</div>
            <div class="sectionImage2 hidden-md hidden-lg hidden-xlg my-10">
              <img class="boxShadow borderRadius8" src="https://cdn.planbook.com/images/schoolTeachers.png"
                :alt="$t('schools.teacher.imageAlt')">
            </div>
            <div>
              <ul class="sectionList md pl-0 my-4">
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.teacher.features.add') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.teacher.features.invite') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.teacher.features.copy') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.teacher.features.update') }}</span></li>
                <li><i class="fal fa-arrow-circle-right" aria-hidden="true"></i><span>{{ $t('schools.teacher.features.assign') }}</span></li>
              </ul>
            </div>
          </v-col>
          <v-col md="6" sm="12" class="hidden-xs hidden-sm hidden-xxs">
            <div class="sectionImage2">
              <img class="boxShadow borderRadius8" src="https://cdn.planbook.com/images/schoolTeachers.png"
                :alt="$t('schools.teacher.imageAlt')">
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Teacher extends Vue {
}
</script>

<style lang="scss" scoped></style>
